import {
  Button,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Radio,
  message,
} from 'antd';
import React, { useEffect } from 'react';
import { NomenclaturesService } from 'services/NomenclaturesService';
import {
  CREATE_ERROR,
  EDIT_ERROR,
  REQUEST_LOADING,
  SUCCESS_CREATE,
  SUCCESS_UPDATE,
} from 'constants/alerts';
import { requiredRule } from 'utils/forms/validationRules';
import { thousandFormatter } from 'utils/forms/formatter';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';

const SERVICE_CODE = '5114';
const PIECE_CODE = '796';

function ProductServicesForm({
  isActive,
  clientId,
  measures,
  onClose,
  onSuccess,
  initialValues,
}) {
  const [form] = Form.useForm();
  const isEditing = initialValues !== null;

  useEffect(() => {
    if (initialValues) {
      const { name, rate, barcode, type, measure_code } = initialValues;

      form.setFieldsValue({
        name,
        rate,
        type,
        measure_code,
        barcode: barcode || '',
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = (values) => {
    if (isEditing) {
      delete values.client_id;
      handleUpdate({ ...values, origin: 'crm' }, initialValues.id);
    } else {
      handleCreate({ ...values, client_id: clientId, origin: 'crm' });
    }
  };

  const handleCreate = async (data) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const resData = await NomenclaturesService.createProductService(data);

      if (resData) {
        handleConfirm(resData);
        message.success(SUCCESS_CREATE);
      }
    } catch (err) {
      message.error(CREATE_ERROR);
    } finally {
      hide();
    }
  };

  const handleUpdate = async (data, id) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const resData = await NomenclaturesService.updateProductService(id, data);

      if (resData) {
        handleConfirm(resData);
        message.success(SUCCESS_UPDATE);
      }
    } catch (err) {
      message.error(EDIT_ERROR);
    } finally {
      hide();
    }
  };

  const handleTypeChange = (event) => {
    const type = event.target.value;
    const measure_code = type === 'product' ? PIECE_CODE : SERVICE_CODE;

    form.setFieldsValue({
      measure_code,
    });
  };

  const handleConfirm = (resData) => {
    onClose();
    onSuccess(resData);
    form.resetFields();
  };

  return (
    <Drawer
      title={
        isEditing ? 'Редактирование номенклатуры' : 'Создание номенклатуры'
      }
      width="50%"
      onClose={onClose}
      visible={isActive}
      zIndex={1002}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        initialValues={{
          type: 'product',
          measure_code: PIECE_CODE,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
      >
        <Form.Item name="name" label="Наименование" rules={[requiredRule]}>
          <Input placeholder="Наименование товара / услуги" allowClear />
        </Form.Item>

        <Form.Item name="rate" label="Цена" rules={[requiredRule]}>
          <InputNumber
            addonAfter="KZT"
            controls={false}
            placeholder="Цена"
            style={{ width: '100%' }}
            formatter={thousandFormatter}
          />
        </Form.Item>

        <Form.Item name="type" label="Тип" rules={[requiredRule]}>
          <Radio.Group onChange={handleTypeChange}>
            <Radio value="product">Товар</Radio>
            <Radio value="service">Услуга</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item name="barcode" label="Штрих-код" initialValue="">
          <Input placeholder="Штрих-код" allowClear />
        </Form.Item>

        <Form.Item name="measure_code" label="Единица" rules={[requiredRule]}>
          <Select
            allowClear
            showSearch
            optionFilterProp="children"
            placeholder="Выберите единицу"
          >
            {measures?.map(({ title, code }) => (
              <Select.Option key={code} value={code}>
                {title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { ProductServicesForm };
